import React, { forwardRef } from "react";
import Icon from "./Icon";
import "./Badge.scss";

// Fontaine M22 — Chip: interactive filter pill (V2 `chip-default` / `chip-active`). Click toggles,
// × removes. Tag is the static sibling; Badge is the status sibling.

/**
 * @param {boolean} [selected]
 * @param {() => void} [onClick]          toggles selection → rendered as a button with aria-pressed
 * @param {() => void} [onRemove]         shows the × (removable filter)
 * @param {ReactNode} [icon]
 * @param {number} [count]
 */
const Chip = forwardRef(function Chip({ children, selected = false, onClick, onRemove, icon, count, disabled = false, className = "", ...rest }, ref) {
  const interactive = typeof onClick === "function";
  const Tag = interactive ? "button" : "span";
  const classes = ["ft-chip", selected ? "is-selected" : "", interactive ? "is-interactive" : "", disabled ? "is-disabled" : "", className].filter(Boolean).join(" ");
  return (
    <Tag
      ref={ref}
      className={classes}
      type={interactive ? "button" : undefined}
      aria-pressed={interactive ? selected : undefined}
      disabled={interactive ? disabled : undefined}
      onClick={interactive && !disabled ? onClick : undefined}
      {...rest}
    >
      {icon ? <span className="ft-chip__icon" aria-hidden="true">{icon}</span> : null}
      <span className="ft-chip__label">{children}</span>
      {typeof count === "number" ? <span className="ft-chip__count">{count}</span> : null}
      {onRemove ? (
        <span
          role="button"
          tabIndex={disabled ? -1 : 0}
          className="ft-chip__remove"
          aria-label={`Remove ${typeof children === "string" ? children : "filter"}`}
          onClick={(e) => { e.stopPropagation(); if (!disabled) onRemove(); }}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); e.stopPropagation(); if (!disabled) onRemove(); } }}
        >
          <Icon name="X" size="xs" />
        </span>
      ) : null}
    </Tag>
  );
});

export default Chip;
